import apiRequest from './client';

// RÈG 4 — Pousantaj sou Maryaj (menu Securite). Portée company / group / bank ;
// au plus une règle par cible côté backend (MaryajRatioRule).

export const listMaryajRatioRules = ({ group, bank } = {}) => {
  const params = new URLSearchParams();
  if (group) params.set('group', group);
  else if (bank) params.set('bank', bank);
  const qs = params.toString();
  return apiRequest(`/maryaj-ratio-rules/${qs ? `?${qs}` : ''}`);
};

export const createMaryajRatioRule = (data) =>
  apiRequest('/maryaj-ratio-rules/', { method: 'POST', body: data });

export const updateMaryajRatioRule = (id, data) =>
  apiRequest(`/maryaj-ratio-rules/${id}/`, { method: 'PATCH', body: data });

export const deleteMaryajRatioRule = (id) =>
  apiRequest(`/maryaj-ratio-rules/${id}/`, { method: 'DELETE' });
